import React, { ReactNode } from 'react'
import { Form } from 'react-bootstrap'

import FeedbackRender, { TFeedbackRender } from './FeedbackRender'
import { TMeta } from './types'

type TFeedback = {
  meta?: TMeta
  children?: ReactNode
}

const Feedback = (props: TFeedback): React.ReactElement => {
  const { meta, children } = props

  const { dirtySinceLastSubmit, error, dirty, submitError, touched } =
    meta || {}

  let feedbackType = ''
  let feedback: TFeedbackRender

  if (dirty || touched) {
    if (error || (submitError && !dirtySinceLastSubmit)) {
      feedbackType = 'invalid'
      feedback = children || error || submitError
    } else {
      feedbackType = 'valid'
    }
  }
  const styleType = {
    styletype: feedbackType,
  }

  return (
    <Form.Control.Feedback
      style={{ display: 'inline' }}
      className={`${feedbackType}-feedback`}
      {...styleType}
    >
      <FeedbackRender feedback={feedback} />
    </Form.Control.Feedback>
  )
}

export default Feedback
